// extracted by mini-css-extract-plugin
export default {"link":"styles_link__dD1wm","action":"styles_action__ziP-B","secondary":"styles_secondary__XHpi5"};